export const DEFAULT_VIRTUAL_SOURCE_MAX = 10;

function translator(value, { relation, virtualSourceMax, targetMax }) {
  let lastSource = 0;
  let lastTarget = 0;
  // eslint-disable-next-line no-plusplus
  for (let rangeIndex = 0; rangeIndex < relation.length; rangeIndex++) {
    const range = relation[rangeIndex];
    const virtualSource = Number.isFinite(range.source) ? range.source : virtualSourceMax;
    const virtualValue = Number.isFinite(value) ? value : virtualSourceMax;
    if (virtualValue <= virtualSource) {
      const relativeY = virtualValue - lastSource;
      const relativeSource = virtualSource - lastSource;
      const relativeTarget = range.target - lastTarget;
      return relativeY * relativeTarget / relativeSource + lastTarget;
    }

    lastSource = virtualSource;
    lastTarget = range.target;
  }

  return targetMax;
}

function yTranslator(y, { yRelation }, { chartSizeModifier, virtualSourceMax, targetMax }) {
  if (y == null) {
    return y;
  }
  return translator(y, { relation: yRelation, virtualSourceMax, targetMax }) * chartSizeModifier;
}

function xTranslator(x, { xRelation }, { chartSizeModifier, virtualSourceMax, targetMax }) {
  if (x == null) {
    return x;
  }
  return translator(x, { relation: xRelation, virtualSourceMax, targetMax }) * chartSizeModifier;
}

export default function builder(pointRelation, {
  targetMax = 100,
  chartSizeModifier = 0.9,
} = {}) {
  function irregularCoordinateTranslator(point, {
    xVirtualSourceMax = DEFAULT_VIRTUAL_SOURCE_MAX,
    yVirtualSourceMax = DEFAULT_VIRTUAL_SOURCE_MAX,
  } = {}) {
    let { x, y } = point;

    if (Array.isArray(point)) {
      [x, y] = point;
    }

    const translatedX = irregularCoordinateTranslator.x(x, {
      virtualSourceMax: xVirtualSourceMax,
      targetMax,
    });
    const translatedY = irregularCoordinateTranslator.y(y, {
      virtualSourceMax: yVirtualSourceMax,
      targetMax,
    });

    return Array.isArray(point)
      ? [translatedX, translatedY]
      : { x: translatedX, y: translatedY };
  }

  irregularCoordinateTranslator.x = (
    x,
    { virtualSourceMax = DEFAULT_VIRTUAL_SOURCE_MAX } = {},
  ) => xTranslator(x, pointRelation, { chartSizeModifier, virtualSourceMax, targetMax });

  irregularCoordinateTranslator.y = (
    y,
    { virtualSourceMax = DEFAULT_VIRTUAL_SOURCE_MAX } = {},
  ) => yTranslator(y, pointRelation, { chartSizeModifier, virtualSourceMax, targetMax });

  return irregularCoordinateTranslator;
}
